import _ from 'lodash';
import {navigationRoutes, navigationSteps} from '../../../redux/modules/navigation/navigationHelpers';
import maestro from '../../../util/maestro/maestro';
import { noEndingSlash } from '../../../util/helpers';
import contentProvider from '../../../redux/modules/contentProvider/contentProvider';
import { CHECKOUT_TYPE_PPV } from '../../../redux/modules/data/review/review';

export const navRoolz = (state) => {
	const currentPath = noEndingSlash(_.get(state, 'routing.locationBeforeTransitions.pathname', ''));
	const flow = _.get(state, 'common.flow');
	const flowType = _.get(state, 'common.flowType', '');
	const consumerType = _.get(state, 'common.consumerType', '');

	const checkoutQueryType = _.get(state, 'checkout.queryType', '');
	const reviewItemFlowType = _.get(state, 'review.content.review.flowType', '');
	const isQuickCheckoutPPV = checkoutQueryType === 'ppv' || reviewItemFlowType === CHECKOUT_TYPE_PPV;

	const quickCheckoutId = _.get(state, 'quickCheckout.quickCheckout.productId', '');
	const serviceLinkContentString = `quickCheckoutProducts.${quickCheckoutId}.backNav`;
	const serviceLink = isQuickCheckoutPPV ? '/learn/ppv' : contentProvider.getValue(serviceLinkContentString, [], 'hide');

	const data = {
		consumerType,
		currentPath,
		flow,
		flowType,
		isQuickCheckoutPPV,
		serviceLink
	};

	const logic = {
		// backNavDestination also controls whether the back button displays. no destination = no button
		backNavDestination: {
			"if": [
				{"and": [
					{"==": [{"var":"currentPath"}, navigationRoutes[navigationSteps.myPlan.MYPLAN].path] },
					{"!=": [{"var":"consumerType"}, "Einstein360"] }
				]},
				'https://customer.xfinity.com/',

				{"or": [
					{"and": [
						{"==": [{"var":"currentPath"}, navigationRoutes[navigationSteps.myPlan.OFFERS_FILTER].path] },
						{"!=": [{"var":"flowType"}, "MoveRepackager"] }
					]},
					{"==": [{"var":"currentPath"}, navigationRoutes[navigationSteps.myPlan.ERROR].path] },
					{"==": [{"var":"currentPath"}, navigationRoutes[navigationSteps.myPlan.CONTACTUS].path] }
				]},
				navigationRoutes[navigationSteps.myPlan.MYPLAN].path,

				{"and": [
					{"or": [
						{"==": [{"var":"currentPath"}, navigationRoutes[navigationSteps.quickCheckout.CHECKOUT].path] },
						{"==": [{"var":"currentPath"}, navigationRoutes[navigationSteps.quickCheckout.REVIEW].path] }
					]},
					{"or": [
						{"==": [{"var":"isQuickCheckoutPPV"}, true] },
						{"!=": [{"var":"serviceLink"}, "hide"] }
					]}
				]},
				data.serviceLink,

				{"and": [
					{"or": [
						{"==": [{"var":"currentPath"}, navigationRoutes[navigationSteps.movers.SPECIALIST].path] },
						{"==": [{"var":"currentPath"}, navigationRoutes[navigationSteps.movers.INSTALL].path] }
					]},
					{"==": [{"var":"flow"}, "movers"] }
				]},
				navigationRoutes[navigationSteps.movers.LOCALIZATION].path
			]
		},
		backNavText: {
			"if": [
				{"==": [{"var":"currentPath"}, navigationRoutes[navigationSteps.myPlan.MYPLAN].path] },
				'Go to My Account',

				{"or": [
					{"==": [{"var":"currentPath"}, navigationRoutes[navigationSteps.myPlan.OFFERS_FILTER].path] },
					{"==": [{"var":"currentPath"}, navigationRoutes[navigationSteps.myPlan.ERROR].path] },
					{"==": [{"var":"currentPath"}, navigationRoutes[navigationSteps.myPlan.CONTACTUS].path] }
				]},
				'Back to My Plan',

				// all others
				'Back'
			]
		},
		backNavIsExternalDestination: {
			"if": [
				{"or": [
					{"==": [{"var":"currentPath"}, navigationRoutes[navigationSteps.myPlan.MYPLAN].path] },
					{"==": [{"var":"currentPath"}, navigationRoutes[navigationSteps.quickCheckout.CHECKOUT].path] },
					{"==": [{"var":"currentPath"}, navigationRoutes[navigationSteps.quickCheckout.REVIEW].path] }
				]}
			]
		},
		showCancelButton: {
			"and": [
				{"==": [{"var":"consumerType"}, "Einstein360"] },
				{"or": [
					{"==": [{"var":"currentPath"}, navigationRoutes[navigationSteps.myPlan.MYPLAN].path] },
					{"==": [{"var":"currentPath"}, navigationRoutes[navigationSteps.myPlan.OFFERS_FILTER].path] },
					{"==": [{"var":"currentPath"}, navigationRoutes[navigationSteps.movers.LOCALIZATION].path] }
				]}
			]
		}
	};

	return maestro.conduct(state, data, logic);
};

// from Mercury's E360OftAccount.jsx
export const closeWindow = data => {
	const parent = window.opener;

  const mapping = [
      // 'http://localhost/e360',
      // 'http://127.0.0.1/e360',
      'https://mcsweb-dt-s1d.cable.comcast.com',
      'https://mcsweb-dt-s1q.cable.comcast.com',
      'https://mcsweb-ch2-a1s.cable.comcast.com',
      'https://einstein360-uat.cable.comcast.com',
      'https://einstein360.cable.comcast.com'
  ];

  if (parent) {
    const msg = Object.assign({}, {sender:'buyflow'}, data);

    Object.keys(mapping).forEach(key => {
      const targetOrigin = mapping[key];

      parent.postMessage(msg, targetOrigin);
    });
    window.close();
  }
};



/** WEBPACK FOOTER **
 ** ./client/components/Common/Nav/navHelpers.js
 **/